import { useState } from "react";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import useVendorStore from "../../AuthStore/store/authStore";
import MyPolicy from "./Customer/MyPolicy";


const UserDashboard = () => {
  const { setUser } = useVendorStore();

  const [activeTab, setActiveTab] = useState("overview");
  // const [notificationSettings, setNotificationSettings] = useState({
  //   email: true,
  //   sms: true,
  //   policyUpdates: true,
  // });

  // ✅ Safe user data construction
  const userData = {
    name: `${setUser?.f_name || ""} ${setUser?.l_name || ""}`.trim(),
    userId:setUser.id,
    email: setUser?.email || "Not provided",
    phone: setUser?.phone || "Not provided",
    status: "active",

    // ⚠️ Don't expose authToken in production
    photo:
      setUser?.photo ||
      "https://ui-avatars.com/api/?background=random&name=" +
        encodeURIComponent(
          `${setUser?.f_name || ""} ${setUser?.l_name || "User"}`
        ),
  
  };

  // const handleNotificationChange = (e) => {
  //   const { name, checked } = e.target;
  //   setNotificationSettings((prev) => ({
  //     ...prev,
  //     [name]: checked,
  //   }));
  // };

  return (
    <div className="min-h-screen bg-gray-100 ">
      {/* Header */}
      {/* <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">User Dashboard</h1>
          <div className="flex items-center">
            <span className="mr-4 text-gray-700">{userData.name}</span>
            <img
              className="h-10 w-10 rounded-full"
              src={userData.photo}
              alt="Profile"
            />
          </div>
        </div>
      </header> */}

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Navigation Tabs */}
        <div className="border-b border-gray-200 mb-8">
          <nav className="-mb-px flex space-x-8">
            {["overview", "policies"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === tab
                    ? "border-indigo-500 text-indigo-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                {tab === "overview" && "Profile Overview"}
                {tab === "policies" && "My Policies"}
                
              </button>
            ))}
          </nav>
        </div>

        {/* Overview */}
        {activeTab === "overview" && (
          <div className="bg-white shadow rounded-lg p-6">
            <div className="flex items-center">
              <img
                className="h-24 w-24 rounded-full mr-6 "
                src={userData.photo}
                alt="Profile"
              />
              <div>
                <h2 className="text-xl font-bold">{userData.name}</h2>
                <p className="text-gray-600">User ID: {userData.userId}</p>
                {/* ⚠️ Removed authToken for security */}
                <span className="mt-2 inline-block px-3 py-1 bg-green-100 text-green-700 text-sm rounded-full">
                  {userData.status}
                </span>
              </div>
            </div>
            <div className="mt-6">
              <h4 className="text-sm font-medium text-gray-500">
                Contact Information
              </h4>
              <div className="mt-2 space-y-2">
                <div className="flex items-center">
                  <FaEnvelope className="h-5 w-5 text-gray-400 mr-2" />
                  <span className="text-sm text-gray-900">
                    {userData.email}
                  </span>
                </div>
                <div className="flex items-center">
                  <FaPhoneAlt className="h-5 w-5 text-gray-400 mr-2" />
                  <span className="text-sm text-gray-900">
                    {userData.phone}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Policies */}
        {activeTab === "policies" && (
          <MyPolicy/>
        )}
      </main>
    </div>
  );
};

export default UserDashboard;
